export default __webpack_public_path__ + "static/media/boost-01@2x.1b60505b.webp";